import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import CheckinPage from './pages/CheckinPage';

function App(): JSX.Element {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<CheckinPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App; 